import { render } from "./ClientGuide.vue?vue&type=template&id=79487106&scoped=true"
import script from "./ClientGuide.vue?vue&type=script&lang=js"
export * from "./ClientGuide.vue?vue&type=script&lang=js"

import "./ClientGuide.vue?vue&type=style&index=0&id=79487106&scoped=true&lang=css"

import exportComponent from "../../../../../../bfms-portal-template-manager-20261102/stage/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79487106"]])

export default __exports__